export default {
  aggregates: {
    aggregated: 'Risultati aggregati',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'fa',
    from: 'da',
    since: 'a partire da',
    unit: {
      DAY: 'giorno|giorni',
      MONTH: 'mese|mesi',
      YEAR: 'anno|anni'
    },
    untilNow: 'fino ad ora'
  },
  categoryDetails: {
    average: 'Media:',
    chartLabel: {
      noLabel: 'No',
      yesLabel: 'Sì'
    },
    description:
      'Questo mostra come vengono distribuite le risposte del team a tutte le domande della categoria.',
    hideOwnAnswers: 'Nascondi le tue risposte',
    noResponses: 'Nessuna risposta',
    notParticipating: 'Non hai risposto tu stesso a queste domande.',
    numberOfPeople: 'Rispondenti:',
    sensitiveQuestion: 'Visibile solo a te in qualità di manager.',
    showFollowUpQuestions: 'Mostra domande di follow-up',
    toggleButton: {
      overview: 'Panoramica',
      questions: 'Domande'
    },
    tooltip: {
      barValue: 'nessuno | {count} persona | {count} persone',
      barValueAnswers: 'nessuno | {count} risposta | {count} risposte'
    },
    workWith: 'Come lavorare con {categoryName}',
    yourResponse: 'Hai risposto:'
  },
  error: {
    couldNotLoadAggregates: 'Impossibile caricare i risultati aggregati.',
    couldNotLoadResults: 'Impossibile caricare i risultati.',
    networkError:
      'Si è verificato un problema durante il caricamento dei dati da Internet.',
    unknown: "C'è un errore sconosciuto"
  },
  errors: {
    status: {
      BadRequest: 'Richiesta al server non valida',
      Forbidden: "L'accesso a questa risorsa non è consentito",
      InternalServerError:
        "Si è verificato un problema sul server. Se il problema persiste, contatta l'assistenza.",
      NotFound: 'Impossibile trovare quello che stai cercando',
      Unauthorized: 'Non sei autorizzato ad accedere a questa risorsa',
      UnknownError: 'Si è verificato un errore sconosciuto'
    }
  },
  freetext: {
    loadResponses: 'Carica risposte',
    noFreeTextQuestions:
      'Se nel tuo sondaggio sono presenti domande a testo libero, potrai visualizzare tutte le risposte qui.',
    notEnoughResponses: 'Risposte non sufficienti.',
    responses: 'Nessuna risposta|{count} risposta | {count} risposte'
  },
  general: {
    add: 'Aggiungi',
    cancel: 'Annulla',
    entireOrganization: 'Intera organizzazione',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      "{value} è il valore medio per richieste nell'ambito di {title}. {compareToBenchmark}",
    currentValue: 'Valore corrente',
    filter: {
      findGroups: 'Trova gruppi',
      shouldExportWithHierarchy: 'Includi gruppi sottostanti'
    },
    loadMore: 'Carica di più',
    loadMoreInGroup: 'Carica altro in {groupName}',
    noone: 'Nessuno ha risposto',
    noResults:
      'Non ci sono ancora risposte sufficienti per questo gruppo. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'hanno risposto',
    nps: 'Net Promoter Score',
    nps_detractors: 'Detrattori',
    nps_passives: 'Passivi',
    nps_promoters: 'Promotori',
    questions: 'Domande nella categoria',
    showTrend: 'Mostra variazione',
    violationsIn:
      "Sono stati segnalati episodi di violazione all'interno di {groupName}. Contatta il dipartimento Risorse Umane che può dirti di più e aiutarti a risolvere il problema."
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected:
        'Seleziona una data come punto di partenza per la cronologia.',
      selectDate: 'Mostra la cronologia dei sondaggi da {date}.',
      selectedDate: 'Visualizzazione della cronologia dei sondaggi dal {date}.'
    },
    selectorOptions: {
      custom: 'personalizzato',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Riprova.'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Sondaggi in corso',
    help: 'Aiuto',
    myActivities: 'Azioni',
    ourResults: 'Risultati',
    overview: 'Panoramica',
    team: 'Team',
    welcome: 'Benvenuto'
  },
  page: {
    results: 'Tutti i risultati'
  },
  resultDetails: {
    backToResults: 'Torna indietro',
    exportData: 'Esporta',
    exportModal: {
      includeSensitiveQuestions: 'Includi domande sensibili',
      loadingMessage:
        "Stiamo preparando i dati per l'esportazione, attendi ancora un attimo!",
      saveAsExcelAllGroupsDescription:
        'Esportando in Excel otterrai un file con i risultati per {groupTitle} e tutti i gruppi sottostanti. Questo è utile se desideri eseguire analisi o calcoli multigruppo personalizzati.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Esportando in Excel otterrai un file con i risultati per {groupTitle}{segmentInfo}. Questo è utile se desideri eseguire analisi o calcoli personalizzati.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Riceverai un documento PDF con i risultati per tutte le categorie e le domande per il gruppo selezionato. Utile quando vuoi stampare i risultati.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        "Un'esportazione in PowerPoint ti fornirà una presentazione accattivante con i risultati per {groupTitle}{segmentInfo}. Perfetto quando devi mostrare i risultati ad altri su uno schermo di grandi dimensioni."
    },
    notes: {
      draggable: {
        explanation: 'Visibile solo a te',
        placeholder:
          'Scrivi qui i tuoi appunti, commenti e riflessioni sul sondaggio',
        title: 'Note personali'
      },
      status: {
        initial: 'Salvataggio automatico durante la digitazione',
        saved: 'Modifiche salvate!',
        unsaved: 'Salvataggio in corso...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Non ci sono abbastanza risposte per visualizzare i risultati per utente'
        },
        description: {
          high: 'Una persona che ha risposto in modo tale da far diventare verde la sua valutazione media.|Ci sono {count} persone che hanno risposto in modo in modo tale da far diventare verde la loro valutazione media.',
          low: 'Una persona che ha risposto in modo tale da far diventare rossa la sua valutazione media.|Ci sono {count} persone che hanno risposto in modo in modo tale da far diventare rossa la loro valutazione media.',
          medium:
            "C'è una persona che ha risposto in modo tale da far diventare gialla la sua valutazione media.|Ci sono {count} persone che hanno risposto in modo in modo tale da far diventare rossa gialla la loro valutazione media."
        },
        title: 'Nessuno|Una persona|{count} persone'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Il tuo punteggio è uguale a quello del benchmark® Pulsᐩ per {title}.',
        higherThanBenchmarkValue:
          'Il tuo punteggio è {benchmarkDiff} superiore al benchmark® Pulsᐩ per {title} che è {benchmarkValue}. Ottimo!',
        lowerThanBenchmarkValue:
          'Il tuo punteggio è {benchmarkDiff} inferiore al benchmark® Pulsᐩ per {title} che è {benchmarkValue}.',
        percentagePoints: 'Punti percentuali'
      },
      enps: {
        button: {
          description:
            'Verrai inviato al nostro partner EQI, che raccoglie dati di benchmarking per un gran numero di organizzazioni e fornisce informazioni più dettagliate sul tuo eNPS-score.',
          title:
            'Confronta il tuo punteggio eNPS con quello di altre organizzazioni'
        }
      },
      toggleButton: {
        history: 'Cronologia',
        overview: 'Panoramica'
      }
    }
  },
  results: {
    aggregated: 'Aggregato',
    chooseSurvey: 'Scegli sondaggio',
    finished: 'Terminato',
    published: 'In corso'
  },
  resultsmessages: {
    disclaimer:
      "Pulsᐩ AI utilizza l'intelligenza artificiale generativa e può commettere errori.",
    error: {
      generic:
        'Oh, oh... qualcosa non sta funzionando come previsto. Prova a ricaricare la pagina.',
      notEnoughResults:
        'Nessun risultato di cui parlare. Seleziona un gruppo o un sondaggio diverso con cui utilizzare Pulsᐩ AI.'
    },
    moreInfo: 'Scopri come utilizzare Pulsᐩ AI come leader',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Fai una domanda sui risultati...',
    reload: 'Ricarica pagina',
    report: 'Segnala problema',
    send: 'Invia',
    suggestionHeader: 'Ecco dei suggerimenti su domande che potresti porre:',
    suggestions: {
      groupsComparison: {
        1: 'Su quali gruppi devo concentrarmi?',
        2: "C'è qualche domanda su cui la maggior parte dei gruppi dovrebbe lavorare?",
        3: 'Quali gruppi mostrano tendenze negative?',
        4: 'Quali gruppi hanno tendenze positive?',
        5: 'Quali gruppi si distinguono negativamente?',
        6: 'Quali gruppi richiedono la mia attenzione?',
        7: 'Cosa devo fare prima?'
      },
      overview: {
        1: 'Cosa dovrei fare con i nostri risultati?',
        2: 'Come dovrei presentare il risultato al mio team?',
        3: 'Nel complesso, come sono i risultati?',
        4: 'Quali sono le 3 azioni principali che dovremmo intraprendere?',
        5: 'Cosa posso migliorare nella mia leadership?',
        6: 'Quali rischi corriamo?',
        7: 'Cosa potrebbe accadere se non agissimo?',
        8: 'A cosa dovrei dare priorità?',
        9: 'Quali sono le previsioni per il mio team?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Tutti'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Confronta'
        },
        export: {
          title: 'Esporta'
        },
        freetext: {
          title: 'Testo libero'
        },
        results: {
          title: 'Risultati del sondaggio'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      "Impossibile mostrare le statistiche senza rischiare di perdere l'anonimato.",
    others: 'Altro | Altri',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Amministrazione',
    currentSurveys: 'Sondaggi in corso',
    dashboard: 'Dashboard',
    help: 'Aiuto',
    logOut: 'Esci',
    myActivities: 'Le mie azioni',
    ourResults: 'I nostri risultati'
  },
  topbanner: {
    preview: {
      body: 'Stai visualizzando la nuova versione dei risultati di Pulsᐩ, che presenta numerosi miglioramenti! Se riscontri un problema o hai commenti o suggerimenti, faccelo sapere! Puoi anche tornare alla versione precedente, se preferisci.',
      header: 'Nuova versione!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Nel periodo di tempo {startDate} - {endDate} il risultato è diminuito per {categoryName}.',
        trend_increased:
          'Nel periodo di tempo {startDate} - {endDate} il risultato è aumentato per {categoryName}. Continuate così!',
        trend_same:
          'Il risultato è rimasto lo stesso per {categoryName} nel periodo di tempo {startDate} - {endDate}.'
      }
    },
    noTrend:
      "Non esiste un'indagine precedente con cui effettuare un confronto.",
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Rispetto al precedente sondaggio del {oldSurveyDate} il risultato mostra un decremento del {changeInPercent}% per {tagName}.',
        nps_trend_increased:
          'Rispetto al precedente sondaggio del {oldSurveyDate} il risultato mostra un aumento da {oldValue} per {categoryName}.',
        nps_trend_same:
          "Il risultato è rimasto più o meno lo stesso (variazione del {changeInPercent}% ) per {tagName} dall'ultimo sondaggio del {oldSurveyDate}.",
        trend_decreased:
          'Nel periodo di tempo {startDate} - {endDate} il risultato è diminuito per {tagName}.',
        trend_increased:
          'Nel periodo di tempo {startDate} - {endDate} il risultato è aumentato per {tagName}',
        trend_same:
          'Il risultato è rimasto lo stesso per {categoryName} nel periodo di tempo {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Tutti i gruppi',
    cannotChangeGroupsWhileComparing:
      'Nella vista di confronto vengono visualizzati più gruppi contemporaneamente.',
    group: 'Gruppo',
    segment: 'Segmento',
    survey: 'Sondaggio'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        "Numero di persone che hanno selezionato almeno un'azione",
      totalActions: 'Numero totale di azioni selezionate'
    },
    title: 'Riepilogo delle azioni'
  },
  widgetAlert: {
    actions: {
      saved: "Grazie, l'attività è stata salvata."
    },
    links: {
      tooltip: 'Il link si apre in una nuova finestra'
    },
    notEnoughData: 'Niente da visualizzare qui al momento.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Segnalazione più di recente {surveyDate}.'
      },
      question: {
        info: 'Domanda più recente: {surveyDate} in "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Non ci sono ancora risposte sufficienti per poter mostrare qualcosa qui.',
    title: 'Categorie',
    tooltip: {
      value:
        "Questo è il valore medio di tutte le risposte alle domande all'interno di {categoryName} a cui hanno risposto le persone in {groupName}."
    }
  },
  widgetErrorFallback: {
    description:
      'Si è verificato un errore imprevisto durante il caricamento del widget. Prova prima a ricaricare la pagina. Se il problema persiste, segnalacelo e lo risolveremo immediatamente!',
    hideErrorDetails: 'Nascondi dettagli errore',
    showErrorDetails: 'Mostra dettagli errore',
    title: 'Problema nel widget!'
  },
  widgetGroupActions: {
    allCategories: "All'interno di tutte le categorie",
    freeText: {
      alert: {
        noResults: "Nessun risultato. Prova a digitare qualcos'altro.",
        typeMore: 'Digita altro'
      },
      filterField: {
        placeholder: 'Digita per trovare i commenti'
      },
      numberOfComments: '{numberOfComments} commenti'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Come sviluppare la responsabilità personale tra i dipendenti'
      }
    },
    noActions: 'Nessuna azione da visualizzare.',
    noActionsSelectedInCategory: 'Non ci sono azioni selezionate',
    otherActions: 'Azioni proprie',
    people: 'nessuno | {count} persona | {count} persone',
    peopleSelectedActions:
      "Su {peopleResponded} persone con risposta, solo 1 ha selezionato almeno un'azione ({percentage}%)| Su {peopleResponded} persone con risposta, {count} persone hanno selezionato almeno un'azione ({percentage}%)",
    title: 'Azioni scelte per le persone in {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 persona ha selezionato questa azione| {count} persone hanno selezionato questa azione'
    }
  },
  widgetGroupPriorities: {
    description:
      'Queste sono le aree più importanti su cui concentrarsi in questo momento, secondo i partecipanti al sondaggio.',
    freeTextResponses: 'Mostra le risposte a testo libero',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Come sviluppare il tuo team con Pulsᐩ'
      }
    },
    noPriorities: 'Non ci sono priorità scelte dai partecipanti.',
    people: 'nessuno | {count} persona | {count} persone',
    thinkImportant: ' pensano che "{category}" sia la più importante',
    title: 'Priorità per le persone in {groupName}'
  },
  widgetNotImplemented: {
    content: 'Non ancora implementato'
  },
  widgetSurveyInfo: {
    endDate: 'Data di conclusione:',
    noone: 'Nessuno ha risposto',
    notEnoughResponses: {
      aggregate:
        'Non sono state fornite risposte sufficienti nel periodo di tempo specificato per poter visualizzare i risultati.',
      completed:
        'Il sondaggio non ha ricevuto risposte sufficienti per poter visualizzare i risultati.',
      published:
        'I lsondaggio non ha ancora ricevuto risposte sufficienti per poter visualizzare i risultati.'
    },
    participation: {
      title: 'Partecipazione'
    },
    startDate: 'Data di inizio:',
    status: {
      completed: 'Sondaggio completato! Questi sono i risultati finali.',
      published:
        'Il sondaggio è ancora in corso. I risultati sono ancora provvisori.'
    },
    usersInvited: 'Persone invitate:',
    usersResponded: 'Persone che hanno risposto:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Questi sono i risultati più recenti per {groupName}.'
    },
    notEnoughResponses:
      'Non ci sono ancora risposte sufficienti per poter mostrare qualcosa qui.',
    title: {
      company: 'Tutti di {organizationName}'
    },
    tooltip: {
      enps_description:
        "eNPS è l'acronimo di Employee Net Promoter Score e misura quanto i dipendenti siano disposti a sostenere l'occupazione nella propria azienda.",
      nps_description:
        "NPS è l'acronimo di Net Promoter Score ed è una misura della probabilità che le persone raccomandino qualcosa ad altri.",
      nps_detractors: 'Detrattori',
      nps_passives: 'Passivi',
      nps_promoters: 'Promotori',
      value:
        'Questo è il valore medio di tutte le risposte alle domande contrassegnate con {tagName} a cui hanno risposto le persone in {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} nel tempo',
    twoTags: '{tag1} e {tag2}'
  }
}
